import React, { Component, useLayoutEffect, useState } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from "react-modal-video";
import ScrollToTop from "react-scroll-up";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import FooterTwo from "../component/footer/FooterTwo";
import logoXrai from "../assets/images/logo/logo_xrai.png";
import serviceImg from "../assets/images/service/service-01.png";
import healthAuthImg from "../assets/images/service/healthauth.png";
import healthImg from "../assets/images/service/health3.png";
import healthAuthImg2 from "../assets/images/service/healthauth2.png";
import fishImg from "../assets/images/service/s5.png";
import ocrImg from "../assets/images/service/s6.png";
import fontImg from "../assets/images/service/s7.png";
import Scrollspy from "react-scrollspy";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import CodeBlock from "./Code";
import FishEx1 from "./service/FishEx";
import FishDescription from "./service/FishDescription";
import OcrDescription from "./service/OcrDescription";
import OcrEx from "./service/OcrEx";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const TermOfUse = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);
  const openModal = () => {
    setIsOpen(true);
  };

  const logo = {
    width: "25%",
  };
  return (
    <React.Fragment>
      {/* Start Pagehelmet  */}
      <PageHelmet pageTitle="Service Details" />
      {/* End Pagehelmet  */}

      {/* <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        /> */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy
                className="mainmenu"
                items={[
                  "home",
                  "company",
                  "solution",
                  "portfolio",
                  // "blog",
                  "contact",
                ]}
                currentClassName="is-current"
                offset={-200}
              >
                <li>
                  <a href="/#home">Home</a>
                  {/* <ul className="submenu">
                      <li className="has-droupdown">
                        <a href="#">Home</a>
                        <ul className="submenu">
                          <li>
                            <a href="#">Submenu</a>
                          </li>
                          <li>
                            <a href="#">Submenu</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="#">Home</a>
                      </li>
                    </ul> */}
                </li>
                <li>
                  <a href="/#company">Company</a>
                </li>
                <li>
                  <Link to="/#solution">Solution</Link>
                </li>
                <li>
                  <Link to="/#portfolio">Portfolio</Link>
                </li>
                {/* <li>
                  <a href="https://google.com">Blog</a>
                </li> */}
                <li>
                  <a href="/#contact">Contact</a>
                </li>
              </Scrollspy>
            </nav>
            {/* <div className="header-btn">
                <a
                  className="rn-btn"
                  href="https://themeforest.net/checkout/from_item/25457315?license=regular"
                >
                  <span>buy now</span>
                </a>
              </div> */}
            {/* Start Humberger Menu  */}
            {/* <div className="humberger-menu d-block d-lg-none pl--20">
                <span
                  onClick={menuTrigger}
                  className="menutrigger text-white"
                >
                  <FiMenu />
                </span>
              </div> */}
            {/* End Humberger Menu  */}
            {/* <div className="close-menu d-block d-lg-none">
                <span onClick={CLoseMenuTrigger} className="closeTrigger">
                  <FiX />
                </span>
              </div> */}
          </div>
        </div>
      </header>
      {/* End Header Area  */}
      {/* Start Breadcrump Area */}
      {/* <div
          className="rn-page-title-area pt--120 pb--190 bg_image bg_image--5"
          data-black-overlay="5"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rn-page-title text-center pt--100">
                  <h2 className="title theme-gradient">WEBSITE DEVELOPMENT</h2>
                  <p>Fresh From The Press Discription</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* End Breadcrump Area */}

      {/* Start Page Wrapper */}
      <div className="rn-service-details ptb--120 bg_color--1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="service-details-inner">
                <div className="inner">
                  <div class="document_283_4 xe_content">
                    <h3>이용 약관</h3>
                    <p>&nbsp;</p>

                    <p>제1조 목적</p>

                    <p>&nbsp;</p>

                    <p>
                      이 약관은 X-RAI가 운영하는 ‘X-RAI API’ 모든 서비스의
                      이용조건 및 절차에 관한 사항과 기타 필요한 사항을
                      전기통신사업법 및 동법 시행령이 정하는 대로 준수하고
                      규정함을 목적으로 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제2조 약관의 효력과 변경</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 이 약관은 X-RAI가 운영하는 ‘‘X-RAI API’
                      웹사이트(www.xrai-api.com) (이하 ‘웹사이트’라 한다)에서
                      온라인으로 공시함으로써 효력을 발생하며, 합리적인 사유가
                      발생할 경우 관련 법령에 위배되지 않는 범위 안에서 개정될
                      수 있습니다. 개정된 약관은 온라인에서 공지함으로써 효력을
                      발휘하며, 이용자의 권리 또는 의무 등 중요한 규정의 개정은
                      사전에 공지합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 합리적인 사유가 발생될 경우에는 이
                      약관을 변경할 수 있으며, 약관을 변경할 경우에는 지체 없이
                      이를 사전에 공시합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 이 약관에 동의하는 것은 정기적으로 웹사이트를 방문하여
                      약관의 변경사항을 확인하는 것에 동의함을 의미합니다.
                      변경된 약관에 대한 정보를 알지 못해 발생하는 이용자의
                      피해는 본 웹사이트에서 책임지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 회원은 변경된 약관에 동의하지 않을 경우 회원
                      탈퇴(해지)를 요청할 수 있으며, 변경된 약관의 효력
                      발생일로부터 7일 이후에도 거부의사를 표시하지 아니하고
                      서비스를 계속 사용할 경우 약관의 변경 사항에 동의한 것으로
                      간주됩니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제3조 약관 외 준칙</p>

                    <p>&nbsp;</p>

                    <p>
                      이 약관에 명시되지 아니한 사항에 대해서는 관계법령 및
                      서비스별 안내의 취지에 따라 적용할 수 있습니다. 이 약관에
                      명시되지 않은 사항이 관계 법령에 규정되어 있을 경우에는 그
                      규정에 따릅니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제4조 용어의 정의</p>

                    <p>&nbsp;</p>

                    <p>
                      이 약관에 명시되지 아니한 사항에 대해서는 관계법령 및
                      서비스별 안내의 취지에 따라 적용할 수 있습니다. 이 약관에
                      명시되지 않은 사항이 관계 법령에 규정되어 있을 경우에는 그
                      규정에 따릅니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>― 제2장 이용계약 체결 ―</p>

                    <p>&nbsp;</p>

                    <p>제5조 이용계약의 성립</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 이용계약은 이용고객의 본 이용약관 내용에 대한 동의와
                      이용신청에 대하여 본 웹사이트 이용승낙으로 성립합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 이용약관에 대한 동의는 이용신청 당시 해당 본
                      웹사이트의 '동의함' 버튼을 누름으로써 의사표시를 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제6조 서비스 이용 신청</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 회원으로 가입하여 본 서비스를 이용하고자 하는
                      이용고객은 본 웹사이트에서 요청하는 제반정보(이름,
                      주민등록번호, 연락처 등)를 제공하여야 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 모든 회원은 반드시 회원 본인의 이름과 주민등록번호를
                      제공하여야만 서비스를 이용할 수 있으며, 실명으로 등록하지
                      않은 사용자는 일체의 권리를 주장할 수 없습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 회원가입은 반드시 실명으로만 가입할 수 있으며 본
                      웹사이트는 실명확인조치를 할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 타인의 명의(이름 및 주민등록번호)를 도용하여
                      이용신청을 한 회원의 모든 ID는 삭제되며, 관계법령에 따라
                      처벌을 받을 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제7조 개인정보정책</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 회원의 개인정보를 보호하며, 그 내용을 본
                      웹사이트 서비스 화면 하단에 '개인정보 정책'이란 이름으로
                      공지합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) '개인정보정책'에서 언급하고 있는 주요 내용은 다음과
                      같습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>가. 본 웹사이트 개인정보정책</p>

                    <p>&nbsp;</p>

                    <p>나. 개인정보의 수집목적 및 이용</p>

                    <p>&nbsp;</p>

                    <p>다. 수집하는 개인정보 항목 및 수집방법</p>

                    <p>&nbsp;</p>

                    <p>라. 개인정보의 보유 및 폐기</p>

                    <p>&nbsp;</p>

                    <p>마. 개인정보의 제공 및 공유</p>

                    <p>&nbsp;</p>

                    <p>바. 개인정보보호를 위한 기술적/제도적 관리</p>

                    <p>&nbsp;</p>

                    <p>사. 자신의 개인정보 열람, 정정 및 삭제</p>

                    <p>&nbsp;</p>

                    <p>아. 어린이의 개인정보보호</p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 본 웹사이트는 '개인정보정책'의 내용이 수정, 변경될
                      경우 변경 이전에 그 내용을 인터넷홈페이지, 전자우편 등의
                      방법을 통해 공지합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제9조 이용 신청의 승낙과 제한</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 제 6조의 규정에 의한 이용신청고객에
                      대하여 업무 수행상 또는 기술상 지장이 없는 경우에
                      원칙적으로 접수순서에 따라 서비스 이용을 승낙합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 아래사항에 해당하는 경우에 대해서
                      승낙하지 아니 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      가. 실명이 아니거나 타인의 명의를 이용하여 신청한 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>나. 이용계약 신청서의 내용을 허위로 기재한 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      다. 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한
                      경우
                    </p>

                    <p>&nbsp;</p>

                    <p>라. 부정한 용도로 본 서비스를 이용하고자 하는 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      마. 영리를 추구할 목적으로 본 서비스를 이용하고자 하는
                      경우
                    </p>

                    <p>&nbsp;</p>

                    <p>바. 기타 규정한 제반사항을 위반하며 신청하는 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 본 웹사이트는 서비스 이용신청이 다음 각 호에 해당하는
                      경우에는 그 신청에 대하여 승낙 제한사유가 해소될 때까지
                      승낙을 유보할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>가. 본 웹사이트가 설비의 여유가 없는 경우</p>

                    <p>&nbsp;</p>

                    <p>나. 본 웹사이트의 기술상 지장이 있는 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      다. 기타 본 웹사이트의 귀책사유로 이용승낙이 곤란한 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 본 웹사이트는 이용신청고객이 관계법령에서 규정하는
                      미성년자일 경우에 서비스별 안내에서 정하는 바에 따라
                      승낙을 보류할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제10조 이용자ID 부여 및 변경</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 이용고객에 대하여 약관에 정하는 바에
                      따라 이용자 ID를 부여합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 이용자ID는 원칙적으로 변경이 불가하며 부득이한 사유로
                      인하여 변경 하고자 하는 경우에는 해당 ID를 해지하고
                      재가입해야 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 이용자ID는 다음 각 호에 해당하는 경우에는 이용고객
                      또는 본 웹사이트의 요청으로 변경할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      가. 이용자ID가 이용자의 전화번호 또는 주민등록번호 등으로
                      등록되어 사생활침해가 우려되는 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>나. 타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우</p>

                    <p>&nbsp;</p>

                    <p>다. 기타 합리적인 사유가 있는 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 서비스 이용자ID 및 비밀번호의 관리책임은 이용자에게
                      있습니다. 이를 소홀이 관리하여 발생하는 서비스 이용상의
                      손해 또는 제3자에 의한 부정이용 등에 대한 책임은
                      이용자에게 있으며 본 웹사이트는 그에 대한 책임을 일절 지지
                      않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (5) 기타 이용자 개인정보 관리 및 변경 등에 관한 사항은
                      서비스별 안내에 정하는 바에 의합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>― 제3장 계약 당사자의 의무 ―</p>

                    <p>&nbsp;</p>

                    <p>제11조 본 웹사이트의 의무</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 이용고객이 희망한 서비스 제공 개시일에
                      특별한 사정이 없는 한 서비스를 이용할 수 있도록 하여야
                      합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 계속적이고 안정적인 서비스의 제공을
                      위하여 설비에 장애가 생기거나 멸실된 때에는 부득이한
                      사유가 없는 한 지체없이 이를 수리 또는 복구합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 본 웹사이트는 개인정보 보호를 위해 보안시스템을
                      구축하며 개인정보 보호정책을 공시하고 준수합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 본 웹사이트는 이용고객으로부터 제기되는 의견이나
                      불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를
                      거쳐 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한
                      경우는 이용자에게 그 사유와 처리일정을 통보하여야 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제12조 이용자의 의무</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 이용자는 회원가입 신청 또는 회원정보 변경 시 실명으로
                      모든 사항을 사실에 근거하여 작성하여야 하며, 허위 또는
                      타인의 정보를 등록할 경우 일체의 권리를 주장할 수
                      없습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 회원은 본 약관에서 규정하는 사항과 기타 협회가 정한
                      제반 규정, 공지사항 등 운영법인이 공지하는 사항 및
                      관계법령을 준수하여야 하며, 기타 본 웹사이트의 운영에
                      방해가 되는 행위, 본 웹사이트의 명예를 손상시키는 행위를
                      해서는 안됩니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 회원은 주소, 연락처, 전자우편 주소 등 이용계약사항이
                      변경된 경우에 해당 절차를 거쳐 이를 운영법인에 즉시 알려야
                      합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 운영법인이 관계법령 및 '개인정보 보호정책'에 의거하여
                      그 책임을 지는 경우를 제외하고 회원에게 부여된 ID의
                      비밀번호 관리소홀, 부정사용에 의하여 발생하는 모든 결과에
                      대한 책임은 회원에게 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (5) 회원은 본 웹사이트의 사전 승낙 없이 서비스를 이용하여
                      영업활동을 할 수 없으며, 그 영업활동의 결과에 대해 본
                      웹사이트는 책임을 지지 않습니다. 또한 회원은 이와 같은
                      영업활동으로 운영법인이 손해를 입은 경우, 회원은
                      운영법인에 대해 손해배상의무를 지며, 본 웹사이트는 해당
                      회원에 대해 서비스 이용제한 및 적법한 절차를 거쳐 손해배상
                      등을 청구할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (6) 회원은 본 웹사이트의 명시적 동의가 없는 한 서비스의
                      이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할
                      수 없으며 이를 담보로 제공할 수 없습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (7) 회원은 운영법인 및 제 3자의 지적 재산권을 침해해서는
                      안됩니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (8) 회원은 다음 각 호에 해당하는 행위를 하여서는 안되며,
                      해당 행위를 하는 경우에 본 웹사이트는 회원의 서비스
                      이용제한 및 적법 조치를 포함한 제재를 가할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      가. 회원가입 신청 또는 회원정보 변경 시 허위내용을
                      등록하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      나. 다른 이용자의 ID, 비밀번호, 주민등록번호를 도용하는
                      행위
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      다. 본 웹사이트의 운영진, 직원 또는 관계자를 사칭하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      라. 운영법인으로부터 특별한 권리를 부여받지 않고 본
                      웹사이트의 클라이언트 프로그램을 변경하거나, 본 웹사이트의
                      서버를 해킹하거나, 웹사이트 또는 게시된 정보의 일부분 또는
                      전체를 임의로 변경하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>마. 서비스에 위해를 가하거나 고의로 방해하는 행위</p>

                    <p>&nbsp;</p>

                    <p>
                      바. 공공질서 및 미풍양속에 위반되는 저속, 음란한 내용의
                      정보, 문장, 도형, 음향, 동영상을 전송, 게시, 전자우편 또는
                      기타의 방법으로 타인에게 유포하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      사. 모욕적이거나 개인신상에 대한 내용이어서 타인의 명예나
                      프라이버시를 침해할 수 있는 내용을 전송, 게시, 전자우편
                      또는 기타의 방법으로 타인에게 유포하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      아. 다른 이용자를 희롱 또는 위협하거나, 특정 이용자에게
                      지속적으로 고통 또는 불편을 주는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      자. 본 웹사이트의 승인을 받지 않고 다른 사용자의
                      개인정보를 수집 또는 저장하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>차. 범죄와 결부된다고 객관적으로 판단되는 행위</p>

                    <p>&nbsp;</p>

                    <p>
                      카. 본 약관을 포함하여 기타 협회가 정한 제반 규정 또는
                      이용 조건을 위반하는 행위
                    </p>

                    <p>&nbsp;</p>

                    <p>타. 기타 관계법령에 위배되는 행위</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>― 제4장 서비스의 이용 ―</p>

                    <p>&nbsp;</p>

                    <p>제13조 서비스 이용 시간</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 서비스 이용은 본 웹사이트의 업무상 또는 기술상 특별한
                      지장이 없는 한 연중무휴, 1일 24시간 운영을 원칙으로
                      합니다. 단, 본 웹사이트는 시스템 정기점검, 증설 및 교체를
                      위해 운영법인이 정한 날이나 시간에 서비스를 일시 중단할 수
                      있으며, 예정되어 있는 작업으로 인한 서비스 일시중단은 본
                      웹사이트를 통해 사전에 공지합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 긴급한 시스템 점검, 증설 및 교체 등
                      부득이한 사유로 인하여 예고없이 일시적으로 서비스를 중단할
                      수 있으며, 새로운 서비스로의 교체 등 운영법인이 적절하다고
                      판단하는 사유에 의하여 현재 제공되는 서비스를 완전히
                      중단할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 본 웹사이트는 국가비상사태, 정전, 서비스 설비의 장애
                      또는 서비스 이용의 폭주 등으로 정상적인 서비스 제공이
                      불가능할 경우, 서비스의 전부 또는 일부를 제한하거나 중지할
                      수 있습니다. 다만 이 경우 그 사유 및 기간 등을 회원에게
                      사전 또는 사후에 공지합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 본 웹사이트는 운영법인이 통제할 수 없는 사유로 인한
                      서비스중단의 경우(시스템관리자의 고의, 과실 없는
                      디스크장애, 시스템다운 등)에 사전통지가 불가능하며
                      타인(PC통신회사, 기간통신사업자 등)의 고의, 과실로 인한
                      시스템중단 등의 경우에는 통지하지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (5) 본 웹사이트는 서비스를 특정범위로 분할하여 각 범위별로
                      이용가능시간을 별도로 지정할 수 있습니다. 다만 이 경우 그
                      내용을 공지합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제14조 이용자 ID 관리</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 이용자ID와 비밀번호에 관한 모든 관리책임은 회원에게
                      있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 이용자 ID에 의하여 제반 이용자
                      관리업무를 수행 하므로 회원이 이용자 ID를 변경하고자 하는
                      경우 운영법인이 인정할 만한 사유가 없는 한 이용자 ID의
                      변경을 제한할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 이용고객이 등록한 이용자 ID 및 비밀번호에 의하여
                      발생되는 사용상의 과실 또는 제 3자에 의한 부정사용 등에
                      대한 모든 책임은 해당 이용고객에게 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제15조 게시물의 관리</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 다음 각 호에 해당하는 게시물이나 자료를
                      사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수
                      있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      가. 다른 회원 또는 제 3자에게 심한 모욕을 주거나 명예를
                      손상시키는 내용인 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      나. 공공질서 및 미풍양속에 위반되는 내용을 유포하거나
                      링크시키는 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>다. 불법복제 또는 해킹을 조장하는 내용인 경우</p>

                    <p>&nbsp;</p>

                    <p>라. 영리를 목적으로 하는 광고일 경우</p>

                    <p>&nbsp;</p>

                    <p>마. 범죄와 결부된다고 객관적으로 인정되는 내용일 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      바. 다른 이용자 또는 제 3자의 저작권 등 기타 권리를
                      침해하는 내용인 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      사. 운영법인에서 규정한 게시물 원칙에 어긋나거나, 게시판
                      성격에 부합하지 않는 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>아. 기타 관계법령에 위배된다고 판단되는 경우</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제16조 게시물에 대한 저작권</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 회원이 서비스 화면 내에 게시한 게시물의 저작권은
                      게시한 회원에게 귀속됩니다. 또한 본 웹사이트는 게시자의
                      동의 없이 게시물을 상업적으로 이용할 수 없습니다. 다만
                      비영리 목적인 경우는 그러하지 아니하며, 또한 서비스내의
                      게재권을 갖습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 회원은 서비스를 이용하여 취득한 정보를 임의 가공,
                      판매하는 행위 등 서비스에 게재된 자료를 상업적으로 사용할
                      수 없습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 본 웹사이트는 회원이 게시하거나 등록하는 서비스 내의
                      내용물, 게시 내용에 대해 제 15조 각 호에 해당된다고
                      판단되는 경우 사전통지 없이 삭제하거나 이동 또는 등록
                      거부할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제16조 게시물에 대한 저작권</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 회원에게 서비스 이용에 필요가 있다고
                      인정되는 각종 정보에 대해서 전자우편이나 서신우편 등의
                      방법으로 회원에게 제공할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 서비스 개선 및 회원 대상의 서비스 소개
                      등의 목적으로 회원의 동의 하에 추가적인 개인 정보를 요구할
                      수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>― 제5장 계약 해지 및 이용 제한 ―</p>

                    <p>&nbsp;</p>

                    <p>제18조 계약 변경 및 해지</p>

                    <p>&nbsp;</p>

                    <p>
                      회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 본
                      웹사이트 내의 회원탈퇴 메뉴를 이용해 가입해지를 해야
                      합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제19조 서비스 이용제한</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 회원이 서비스 이용내용에 있어서 본 약관
                      제 11조 내용을 위반하거나, 다음 각 호에 해당하는 경우
                      서비스 이용을 제한할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>가. 미풍양속을 저해하는 비속한 ID 및 별명 사용</p>

                    <p>&nbsp;</p>

                    <p>
                      나. 타 이용자에게 심한 모욕을 주거나, 서비스 이용을 방해한
                      경우
                    </p>

                    <p>&nbsp;</p>

                    <p>다. 기타 정상적인 서비스 운영에 방해가 될 경우</p>

                    <p>&nbsp;</p>

                    <p>
                      라. 정보통신 윤리위원회 등 관련 공공기관의 시정 요구가
                      있는 경우
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 상기 이용제한 규정에 따라 서비스를 이용하는 회원에게
                      서비스 이용에 대하여 별도 공지 없이 서비스 이용의
                      일시정지, 초기화, 이용계약 해지 등을 불량이용자 처리규정에
                      따라 취할 수 있습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>― 제6장 손해배상 및 기타사항 ―</p>

                    <p>&nbsp;</p>

                    <p>제20조 손해배상</p>

                    <p>&nbsp;</p>

                    <p>
                      본 웹사이트는 서비스에서 무료로 제공하는 서비스의 이용과
                      관련하여 개인정보보호정책에서 정하는 내용에 해당하지 않는
                      사항에 대하여는 어떠한 손해도 책임을 지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제21조 면책조항</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 본 웹사이트는 천재지변, 전쟁 및 기타 이에 준하는
                      불가항력으로 인하여 서비스를 제공할 수 없는 경우에는
                      서비스 제공에 대한 책임이 면제됩니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 본 웹사이트는 기간통신 사업자가 전기통신 서비스를
                      중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우
                      책임이 면제됩니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (3) 본 웹사이트는 서비스용 설비의 보수, 교체, 정기점검,
                      공사 등 부득이한 사유로 발생한 손해에 대한 책임이
                      면제됩니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (4) 본 웹사이트는 회원의 귀책사유로 인한 서비스 이용의
                      장애 또는 손해에 대하여 책임을 지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (5) 본 웹사이트는 이용자의 컴퓨터 오류에 의해 손해가
                      발생한 경우, 또는 회원이 신상정보 및 전자우편 주소를
                      부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (6) 본 웹사이트는 회원이 서비스를 이용하여 기대하는 수익을
                      얻지 못하거나 상실한 것에 대하여 책임을 지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (8) 본 웹사이트는 회원이 서비스를 이용하면서 얻은 자료로
                      인한 손해에 대하여 책임을 지지 않습니다. 또한, 본
                      웹사이트는 회원이 서비스를 이용하며 타 회원으로 인해 입게
                      되는 정신적 피해에 대하여 보상할 책임을 지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (9) 본 웹사이트는 회원이 서비스에 게재한 각종 정보, 자료,
                      사실의 신뢰도, 정확성 등 내용에 대하여 책임을 지지
                      않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (10) 본 웹사이트는 이용자 상호간 및 이용자와 제 3자 상호
                      간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가
                      없으며, 이로 인한 손해를 배상할 책임도 없습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (11) 운영법인에서 회원에게 무료로 제공하는 서비스의 이용과
                      관련해서는 어떠한 손해도 책임을 지지 않습니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>제22조 재판권 및 준거법</p>

                    <p>&nbsp;</p>

                    <p>
                      (1) 이 약관에 명시되지 않은 사항은 전기통신사업법 등
                      관계법령과 상관습에 따릅니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>
                      (2) 서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는
                      경우 본 웹사이트의 운영법인 소재지를 관할하는 법원을 관할
                      법원으로 합니다.
                    </p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>＊ 부칙</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>(시행일) 본 약관은 2022년 1월부터 적용됩니다.</p>
                    <div class="document_popup_menu">
                      <a
                        href="#popup_menu_area"
                        class="document_283"
                        onclick="return false"
                      >
                        이 게시물을
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Wrapper */}

      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}

      <FooterTwo />
    </React.Fragment>
  );
};

export default TermOfUse;
